<template>
  <div />
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';

const {
  ItemTypeConsts,
  StoreModuleMap,
} = Constants;

const notificationsCollection = StoreModuleMap[ItemTypeConsts.notification];
const settingsModule = StoreModuleMap[ItemTypeConsts.settings];

export default {
  name: 'Notifications',

  clearInterval: window.clearInterval.bind(window),

  setInterval: window.setInterval.bind(window),

  data() {
    return {
      notificationsCountUpdateInterval: 0,
    };
  },

  computed: {
    ...mapGetters(settingsModule, [
      'isCommandRunner',
    ]),

    ...mapState(settingsModule, [
      'orgId',
    ]),
  },

  async mounted() {
    await this.handleMounted();
  },

  destroyed() {
    this.clearNotificationsUpdate();
  },

  methods: {
    ...mapActions(notificationsCollection, [
      'fetchNotificationsCount',
    ]),

    /**
     * Clear the 30-second interval that updates the notifications count
     */
    clearNotificationsUpdate() {
      if (this.notificationsCountUpdateInterval) {
        this.$options.clearInterval(this.notificationsCountUpdateInterval);
      }
    },

    async handleMounted() {
      if (!this.isCommandRunner && this.orgId && typeof window.mocha === 'undefined') {
        await this.setNotificationsUpdate();
      }
    },

    /**
     * Set an interval to update the notifications count every 30 seconds
     */
    async setNotificationsUpdate() {
      await this.fetchNotificationsCount();
      this.notificationsCountUpdateInterval = this.$options
        .setInterval(this.fetchNotificationsCount, 30000);
    },
  },
};
</script>
